import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSExpenseCategoryServices {

    static createExpenseCategoryByPharmacyId(id, data) {
        return axios.post(`${URL.PMS_CREATE_EXPENSE_CATEGORY_BY_PHARMACY_ID}/${id}`, data, PMSExpenseCategoryServices.getAuthHeader())
    }

    static getAllExpenseCategoriesByPharmacyId(id, params) {
        return axios.get(`${URL.PMS_READ_EXPENSE_CATEGORY_BY_PHARMACY_ID}/${id}`, {
            ...PMSExpenseCategoryServices.getAuthHeader(),
            params
        })
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return { headers: { "Authorization": `Bearer ${accessToken}` } };
    }

}
